import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Link, Router, Routes } from "react-router-dom";
import "./index.css";
import App from "./App.js";
import reportWebVitals from "./reportWebVitals";
import Logo from "./triquetra-full-logo.svg";
import LoadingLogo from "./components/LoadingLogo";
import WebGIS from "./WebGIS.js";
import LoginPage from "./components/LoginPage";
import axios from "axios";
import { checkboxClasses } from "@mui/material";
import webGiSImage from "./WebGISScreenShot copy.png";
import kbpImage from "./bibliographyLandingPageResized.png";
import DSS from "./DSS.js";

const host = process.env.REACT_APP_HOST;

const root = ReactDOM.createRoot(document.getElementById("root"));

// Landing Page Component
function LandingPage() {
  const [loadingVisible, setLoadingVisible] = useState(true);
  const [loginAUTH, setLoginAUTH] = useState(false);
  const [loginVisible, setLoginVisible] = useState(true);
  useEffect(() => {
    axios
      .get(`${host}/checklogin`, { withCredentials: true })
      .then((response) => {
        console.log(response);
        const checkLogin = response.data;
        if (checkLogin === "loginTrue") {
          const loginContainer = document.getElementById("login-container");
          if (loginContainer) {
            loginContainer.style.display = "none";
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingVisible(false);
    }, 2300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="landing-page">
      {loadingVisible && <LoadingLogo />}
      {!loginAUTH && <LoginPage setLoginAUTH={setLoginAUTH} />}
      <header>
        <div className="header">
          <img src={Logo} alt="Company Logo" className="logo" />
        </div>
      </header>
      <div className="main-page">
        {/* <div className="background"></div> */}
        <div className="knowledge-GIS-container">
          <div className="knowledge-base">
            <div className="knowledge-base-header"> TRIQUETRA BIBLIOGRAPHY</div>
            <div className="KBP">
              <img
                src={kbpImage}
                style={{ width: "100%", height: "100%" }}
              ></img>
            </div>
            <div className="biblio">
              <Link to="/bibliography">
                <button className="goto-button">EXPLORE</button>
              </Link>
            </div>
          </div>
          <div className="web-GIS-container">
            <div className="WEb-GIS-header"> TRIQUETRA WEBGIS</div>
            <div className="WGS">
              <img
                src={webGiSImage}
                style={{ width: "100%", height: "100%" }}
              ></img>
            </div>
            <div className="webGIS">
              <Link to="/webgis">
                <button className="goto-button">WEBGIS</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Routes>
      <Route path="/" exact element={<LandingPage />} />
      <Route path="/bibliography" element={<App />} />
      <Route path="/webgis" element={<WebGIS />} />
      <Route path="/dss" element={<DSS />} />
    </Routes>
  </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
